import { NotificationResponse } from '@/client/types.gen';

/**
 * Determines if a notification is unread
 *
 * A notification is considered unread if it hasn't been read AND hasn't been acted upon.
 *
 * Why check both fields?
 * The backend sets either `read_at` or `acted_upon` depending on whether the notification
 * is actionable or not. Due to async programming, the `status` field represents the last
 * action that completed, which could be 'sent', 'read', 'acted_upon', etc. This means
 * we can't rely solely on the status field.
 *
 * Instead, we check the timestamp fields directly:
 * - `read_at`: Set when a non-actionable notification is read
 * - `acted_upon`: Set when an actionable notification is acted upon (accept/reject)
 *
 * A notification is unread only if BOTH fields are null/undefined.
 */
export const isNotificationUnread = (notification: NotificationResponse): boolean => {
	return !notification.read_at && !notification.acted_at;
};

/**
 * Extracts the pending_share_id from notification action_data if it exists
 */
export const getPendingShareId = (notification: NotificationResponse): number | null => {
	const shareId = notification.action_data?.pending_share_id;
	return typeof shareId === 'number' ? shareId : null;
};
